export const COMPONENT_KEYS = {
  FREE: 'free',
  RECHARGE: 'recharge',
  PRODUCT: 'product',
};

export const PRODUCT_FREE = 0;
